import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Enterprise } from 'app/models/enterprise.model';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseService {

  apiUrl: string = `${environment.apiUrl}enterprise`;
  constructor(private httpClient: HttpClient) { }

  saveEnterprise(enterprise: Enterprise){
    try {
      if(enterprise.id){
        console.log('Actualizar empresa');
        return this.httpClient.put<Enterprise>(this.apiUrl, enterprise).pipe(
          catchError(this.handleError)
        );
      }else{
        console.log('Guardar nueva empresa');
        return this.httpClient.post<Enterprise>(this.apiUrl, enterprise).pipe(
          catchError(this.handleError)
        );
      }
    } catch (error) {
      console.error(error);
    }
  }

  getEnterprise(id: number){
    try {
      return this.httpClient.get<Enterprise>(this.apiUrl + `/${id}`);
    } catch (error) {
      console.error(error);
    }
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
}
